import { Menu, MenuItem, TextField } from "@mui/material";
import React from "react";
import { ui } from "../../../../../../interfaces/interfaces";
import { useAppSelector } from "@store/hooks";
import { inputComponentLogger } from "@utils/general";

const name = "CustomerMenu"

const a11yProps = (name: string) => {
    return {
        id: `input-${name.toLowerCase()}`,
        name: name,
        fullWidth: true,
        autoComplete: 'none',
        "aria-controls": `action-input-${name.toLowerCase()}`,
    };
}

const menuId = 'primary-search-customer-menu';

const handleMenuClose = () => {
    ui.CustomerNameInputModal = false
};

const handleMenuCloseAndSave = (propertyName: string) => {
    ui.CallerName = propertyName
    ui.CustomerNameInputModal = false
};

type CustomerMenuProps = {
    anchorEl: HTMLElement | null;
}

const CustomerMenu: React.FC<CustomerMenuProps> = ({ anchorEl }) => {
    const customerMenuOpen = useAppSelector(({ ui }) => ui.CustomerNameInputModal);
    const [propertyName, setPropertyName] = React.useState("")

    return (<Menu
        anchorEl={anchorEl}
        anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
        id={menuId}
        keepMounted
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        open={customerMenuOpen}
        onClose={() => handleMenuClose()}
    >
        <MenuItem>
            <TextField {...a11yProps("CallerName")} label="First name" onKeyPress={(ev) => {
                if (ev.key === 'Enter') {
                    ev.preventDefault();
                    handleMenuCloseAndSave(propertyName)
                }
            }}
                onChange={(e) => setPropertyName(e.target.value)}
                onBlur={(e) =>
                    inputComponentLogger(`[App]▷[${name}]`, e.target.value)
                }
                value={propertyName}
            />
        </MenuItem>
    </Menu>
    );
}

CustomerMenu.displayName = name

export default React.memo(CustomerMenu);